import React from 'react';
import { ChevronDown } from 'lucide-react';
import { cn } from '@/app/_module/lib/utils';
import { focusRing } from './primitives';

/** Raw registration IDs. Only support needs them, so they stay folded away. */
export function SupportIds({ ids }: { ids: { label: string; value?: string | null }[] }) {
  const present = ids.filter((i) => i.value);
  if (present.length === 0) return null;

  return (
    <details className="group rounded-xl border border-neutral-200/80 bg-white">
      <summary
        className={cn(
          'flex min-h-12 cursor-pointer list-none items-center justify-between gap-3 rounded-xl px-4 py-3 text-sm font-medium text-neutral-700 transition-colors hover:bg-neutral-50 group-open:rounded-b-none sm:px-5 [&::-webkit-details-marker]:hidden',
          focusRing,
        )}
      >
        Registration IDs for support
        <ChevronDown aria-hidden className="size-4 text-neutral-500 transition-transform group-open:rotate-180" />
      </summary>
      <dl className="grid gap-4 border-t border-neutral-100 px-4 py-4 sm:grid-cols-2 sm:px-5">
        {present.map((i) => (
          <div key={i.label} className="min-w-0">
            <dt className="text-xs text-neutral-500">{i.label}</dt>
            <dd className="mt-0.5 break-all font-mono text-[13px] text-neutral-900">{i.value}</dd>
          </div>
        ))}
      </dl>
    </details>
  );
}
